import { useMutation } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { postResetPassword } from "../api/admin";

const usePostResetPassword = () => {
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation({
    mutationFn: postResetPassword,
    onSuccess: (data) => {
      enqueueSnackbar(data.message, {
        variant: "success",
      });
    },
  });

  return mutation;
};

export default usePostResetPassword;
